import { Routes } from '@/constants/routes'
import type { Icon } from '@alice-health/wonderland'

export interface MenuRule {
  featureName: string
  field: string
}

export interface MenuItem {
  icon: Icon
  title: string
  path?: string
  link?: string
  rules?: MenuRule[]
  children?: MenuItem[]
}

const shouldAuditChannelMenu: MenuRule[] = [
  {
    featureName: 'channels-should_show_audit_channels_by_id',
    field: 'id'
  },
  {
    featureName: 'channels-should_show_audit_channels_by_role',
    field: 'roles'
  }
]

const shouldAuditFileMenu: MenuRule[] = [
  {
    featureName: 'file_vault-should_show_audit_file_by_id',
    field: 'id'
  },
  {
    featureName: 'file_vault-should_show_audit_file_by_role',
    field: 'roles'
  }
]

const shouldIdentifyMemberMenu = [
  {
    featureName: 'sherlock-should_show_identify_member_by_role',
    field: 'roles'
  }
]

const menuItems: MenuItem[] = [
  {
    icon: 'icSearch',
    title: 'Requisitar',
    path: 'requisitar',
    link: Routes.request
  },
  {
    icon: 'icBullets',
    title: 'Minhas Queries',
    path: 'minhas-queries',
    link: Routes.myQueries
  },
  {
    icon: 'icHashtag',
    title: 'Auditar canais',
    rules: shouldAuditChannelMenu,
    children: [
      {
        icon: 'icHashtag',
        title: 'Por código interno',
        path: 'auditar-canais-mic',
        link: Routes.channel
      },
      {
        icon: 'icHashtag',
        title: 'Por lista',
        path: 'auditar-canais-lista',
        link: Routes.channelByList
      }
    ]
  },
  {
    icon: 'icPaper',
    title: 'Auditar arquivos',
    path: 'auditar-arquivos',
    rules: shouldAuditFileMenu,
    link: Routes.files
  },
  {
    icon: 'icUser',
    title: 'Identificar Membro',
    path: 'identificar-membro',
    rules: shouldIdentifyMemberMenu,
    link: Routes.identifyMember
  }
]

export default menuItems
